import Router from '@/router'; 

export function checkSQLerrors(data){	
  
    if (typeof data.sql_errors !== 'undefined'){
        console.log(`%c ${new Date().toLocaleString()}: SQL ERROR `, 'background: red; color: white; font-size:1.2rem;');
        throw 'Invalid SQL';
    }
}

export async function checkAuth(response){

    if (response.status == 200){
        let data = await response.json();
        checkSQLerrors(data);
        return data;
    }

    if (response.status == 403){
        Router.push('/access-denied');
        return
    }

    if (response.status == 401){
        let data = await response.json();
        switch(data.message){
            case 'Token not found.':
                Router.push('/admin/login');
                break;

            case 'page restricted':
                Router.push('/access-denied');
                break;

            case 'admin not logged in':
                Router.push('/admin/login');
                break;

            case 'not logged in':
                Router.push('/login');
                break;
                
            case 'parent page restricted':
                Router.push('/outlets');
                break;
        }
        
        return;
    }
}

export function formatNumber(number, dp=2){
    if (isNaN(number)){
        number = 0;
    }
    return parseFloat(number).toFixed(dp);
}

export function shallowCopy(object){
    return Object.assign({}, object);
}

export function getSum(array, field){
    return Number(
        array.reduce(
            (sum, item) => sum + Math.abs(Number(item[field] || 0)),
            0
        ).toFixed(2)
    );
}

export function openModal(modal_id){
    document.getElementById(modal_id).classList.remove('hidden');
}

export function closeModal(modal_id){
    document.getElementById(modal_id).classList.add('hidden');
}

export function generateToken(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

export function deepCopyObject(object){
    let deep_copy = JSON.parse(JSON.stringify(object));

    return deep_copy;
}

export function setMetaTags(title_tag, description_tag, keywords_tag, canonical_url) {
    const meta_title       = document.querySelector('head title');
    const meta_description = document.querySelector('head meta[name="description"]');
    const meta_keywords    = document.querySelector('head meta[name="keywords"]');
    const canonical_link   = document.querySelector('link[rel="canonical"]');

    meta_title.textContent = title_tag;
    meta_description.setAttribute('content', description_tag);
    meta_keywords.setAttribute('content', keywords_tag);
    canonical_link.setAttribute('href', canonical_url);
}

export function formatStyles(object){
    let styles = {};

    Object.keys(object).forEach(key => {
        const value = object[key];
        styles[value.css_property] = value.value;
    });
    
    return styles;
}

export function compileStyles(object){
    let styles = {};

    Object.keys(object).forEach(key => {
        const value = object[key];
        styles[value.css_property] = value.value;
    });

    return styles;
}

export function findContainerThatContainsBlocks(containers, block_id){
    let container = {};
    let found = false;

    for (let i = 0; i <containers.length; i++) {
        let current_container = containers[i];

        for (let j = 0; j < current_container.blocks.length; j++) {
            let current_row = current_container.blocks[j];

            if(current_row.id == block_id){
                container = current_container;
                found = true;
                break;
            }
        }

        if(found){
            break;
        }
    }

    return container;
}

export function deleteDynamicCss(stylesheet_id){
    let dynamic_page_custom_css = document.getElementById(stylesheet_id);

    if(dynamic_page_custom_css != null){
        dynamic_page_custom_css.remove();
    }
}

export function importDynamicCss({css = '', stylesheet_id = 'dynamic_page_custom_css', remove_old_css = true, scope_to = '' }={}){
    if(typeof css !== 'undefined'){

        if(remove_old_css){
            let dynamic_page_custom_css = document.getElementById(stylesheet_id);
        
            if(dynamic_page_custom_css != null){
                dynamic_page_custom_css.remove();
            }
        }

        if(scope_to != ''){
            css = `${scope_to}{${css}}`;
        }
    
        let blob = new Blob([css], {type: 'text/css'});
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = window.URL.createObjectURL(blob);
        link.id = stylesheet_id;
    
        let head = document.getElementsByTagName('head')[0];
        head.appendChild(link);
    }
}

export function importFonts(stylesheet_id){ //Google fonts only
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = "https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Exile&family=Playfair+Display:ital,wght@0,400..900;1,400..900&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100..900;1,100..900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap";
    link.id = stylesheet_id;

    let head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
}

export function triggerPrerenderEvent(){
    if (window.__PRERENDER_INJECTED){ //For prerender on prod build
        document.dispatchEvent(new Event('prerender-trigger-event')); 
    }
}

export function formatUrlForCachedFiles(url){
    let formatted_url = decodeURIComponent(url).toLowerCase();
    formatted_url     = (formatted_url[0] !== '/') ? '/' + formatted_url : formatted_url;
    formatted_url     = formatted_url.replace(/\/+$/, '');// Remove trailing slash
    formatted_url     = formatted_url.replace(/[^a-zA-Z0-9-\/]+/g,"-").replaceAll('/', '__'); //Replace all nonalphanumeric chars
    return formatted_url;
}

export function sanitizeSlug(input) {
    // Decode HTML entities like &#233; to é
    const textarea = document.createElement('textarea');
    textarea.innerHTML = input;
    let str = textarea.value;

    // Convert to lowercase
    str = str.toLowerCase();

    // Manual transliteration (replace accented characters)
    const translitMap = {
        'ü': 'u', 'Ü': 'u', 'é': 'e', 'ã': 'a',
        'Ä': 'a', 'ä': 'a', 'Ö': 'o', 'ö': 'o',
        'ê': 'e', 'è': 'e', 'ô': 'o', 'ó': 'o', 'ú': 'u',
    };
    str = str.replace(/./g, char => translitMap[char] || char);

    // Replace all non-alphanumeric characters with space
    str = str.replace(/[^a-z0-9]+/g, ' ');

    // Replace whitespace with dashes
    str = str.replace(/\s+/g, '-');

    // Replace multiple dashes with one
    str = str.replace(/-+/g, '-');

    // Trim leading/trailing dashes
    str = str.replace(/^-+|-+$/g, '');

    return str;
}
export function firePurchaseEvent(order) {
    let ga_items = [];

    ga_items = order.items.map((item, index) => ({
        item_id: item.product_id,
        item_name: item.product_name,
        affiliation: "",
        coupon: "",
        discount: 0,
        index: index,
        item_brand: "",
        item_category: "",
        item_category2: "",
        item_category3: "",
        item_category4: "",
        item_category5: "",
        item_list_id: "",
        item_list_name: "",
        item_variant: "",
        location_id: "",
        price: item.price,
        quantity: item.quantity
    }));

    gtag('event', 'purchase', {
        transaction_id : order.order_no,
        value: order.order_amount,
        tax: 0,
        shipping: 0,
        currency: "GBP",
        items: ga_items
    });
}

export function checkOmetriaLoaded() {
    let ometria_loaded = false;
    if(typeof window.ometria !== 'undefined') {
        ometria_loaded = true;
    }

    return ometria_loaded;
}

export function fireOmetriaBasketEvent(cart, basket_id) {
    if(checkOmetriaLoaded()) {
        var basket = new ometria.Basket();
        basket.setId(basket_id);
        basket.setUrl(window.location.href);
        
        let total = 0;
        cart.forEach(item => {
            total += item.price * item.quantity;
            basket.addLineItem(item.product_id, item.quantity, item.price);
        });
        
        total = Number(formatNumber(total));
        basket.setTotal(total, "GBP");
        ometria.setBasket(basket);
    }
}

export function fireOmetriaCustomEvent(event_type, product) {
    if(checkOmetriaLoaded()) {
        ometria.track('custom_event', {
            event_type: event_type,
            product_id: product.code,
            product_name: product.productname,
            product_price: product.price
	    });
    }
}

export function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
export function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export async function fetchPdf(pdf_token){
    let response = await fetch(`/api/fetch-files?type=document_pdf&token=${pdf_token}`, {
        credentials: "include",
    });

    if (response.status !== 200) {
        return null;
    }

    const blob = await response.blob();

    if (blob.type !== 'application/pdf') {
        return null;
    }

    return URL.createObjectURL(blob);
}

export async function removePdf(pdf_token) {
    let response = await fetch(`/api/files/remove`, {
        method: 'DELETE',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            type: 'pdf',
            token: pdf_token,
        })
    });

    let results = await checkAuth(response);

    if (response.status === 200) {}
}